import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-vercel', 'BrandVercel', [["path",{"d":"M3 19h18l-9 -15l-9 15"}]]);